module.exports = __webpack_public_path__ + "img/icon-instagram.48ad3b5f.svg";